<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-button type="primary" @click="addPermission" style="width: 96px">新增权限</el-button>
                </div>
            </div>
            <div>
                <el-table :data="tableData.slice((this.pageNum-1)*this.pageSize,this.pageNum*this.pageSize)"
                          :header-cell-style="{'padding-left': '3%'}"
                          :cell-style="{'padding-left': '3%'}">
                    <el-table-column prop="permissionName" label="权限名称"></el-table-column>
                    <el-table-column prop="permissionDesc" label="权限描述"></el-table-column>
                    <el-table-column prop="menuId" label="菜单名称"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="editPermission(scope.row)">编辑</el-button>
                            <el-button type="text" class="delete-button" @click="deletePermission(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="新增权限" :visible.sync="dialogAddVisible" width="520px" :close-on-click-modal="false">
            <el-form :model="permissionAdd" ref="addPermission" size="small">
                <el-form-item label="菜单名称" label-width="100px" prop="menuId">
                    <el-select v-model="permissionAdd.menuId" placeholder="请选择具体菜单" style="width: 282px">
                        <el-option v-for='item in result_list' :key="item.menuId" :label="item.menuCaption" :value="item.menuId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="权限名称" label-width="100px" prop="permissionName">
                    <el-input v-model="permissionAdd.permissionName" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="权限描述" label-width="100px" prop="permissionDesc">
                    <el-input v-model="permissionAdd.permissionDesc" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogAddVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑诊断" :visible.sync="dialogEditVisible" width="520px" :close-on-click-modal="false">
            <el-form :model="permissionEdit" ref="editPermission" size="small">
                <el-form-item label="菜单名称" label-width="100px">
                    <el-select v-model="permissionEdit.menuId" placeholder="请选择具体菜单" style="width: 282px">
                        <el-option v-for='item in result_list' :key="item.menuId" :label="item.menuCaption" :value="item.menuId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="权限名称" label-width="100px">
                    <el-input v-model="permissionEdit.permissionName" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="权限描述" label-width="100px">
                    <el-input v-model="permissionEdit.permissionDesc" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEditVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                authorization:localStorage.getItem('authorization'),
                result_list: [],
                // 表格信息
                tableData: [],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 1,
                // 弹窗开关
                dialogAddVisible: false,
                dialogEditVisible: false,
                // 新增诊断弹窗数据
                permissionAdd:{
                    menuId: '',
                    permissionName: '',
                    permissionDesc: '',
                },
                // 编辑诊断弹窗数据
                permissionEdit: {
                    menuId: '',
                    permissionId: '',
                    permissionName: '',
                    permissionDesc: '',
                },
            }
        },
        methods: {
            // 获取子菜单
            getMenu() {
                this.axios.get('/api-b/10025/100056', {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if(res.data.code === 10000) {
                        const menu = res.data.data.result_list
                        for(let i=0; i<menu.length; i++) {
                            if (menu[i].children.length !== 0) {
                                for (let j=0; j<menu[i].children.length; j++) {
                                    this.result_list.push(menu[i].children[j])
                                }
                            } else {
                                this.result_list.push(menu[i])
                            }
                        }
                    } else if(res.error === 'access_denied') {
                        this.$message.error(res.error_description)
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 获取全部权限
            queryPermission() {
                this.axios.get('/api-u/10022/100039',{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.tableData = res.data.data
                        this.total = res.data.data.length
                    } else if(res.error === 'access_denied') {
                        this.$message.error(res.error_description)
                    } else {
                        this.$message.error(res.data.message)
                    }
                }).catch(error => {
                    this.$message.error(error)
                })
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
            },
            // 打开新增权限弹窗
            addPermission() {
                this.dialogAddVisible =true
                this.$nextTick(() => {
                    this.$refs.addPermission.resetFields()
                })
            },
            // 确定添加权限
            confirmAdd() {
                let params = this.permissionAdd
                this.axios.post('/api-u/10022/100036',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dialogAddVisible = false
                        this.$message.success(res.data.message)
                        this.queryPermission()
                    } else if(res.error === 'access_denied') {
                        this.$message.error(res.error_description)
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 打开编辑诊断弹窗
            editPermission(data) {
                this.dialogEditVisible = true
                this.permissionEdit = JSON.parse(JSON.stringify(data))
            },
            // 确认编辑诊断
            confirmEdit() {
                let params = {
                    permissionId: this.permissionEdit.permissionId,
                    menuId: this.permissionEdit.menuId,
                    permissionName: this.permissionEdit.permissionName,
                    permissionDesc: this.permissionEdit.permissionDesc,
                }
                this.axios.put('/api-u/10022/100037/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dialogEditVisible = false
                        this.$message.success(res.data.message)
                        this.queryPermission()
                    } else if(res.error === 'access_denied') {
                        this.$message.error(res.error_description)
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 删除权限
            deletePermission(date) {
                this.$confirm('您确认要删除此权限?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.delete('/api-u/10022/100038/' + date.permissionId,{
                        headers:{
                            Authorization: this.authorization
                        }
                    }).then(res =>{
                        if(res.data.code === 10000) {
                            this.$message.success(res.data.message);
                            // 查询现有角色
                            this.queryPermission()
                        } else if(res.error === 'access_denied') {
                            this.$message.error(res.error_description)
                        } else {
                            this.$message.error(res.data.message)
                        }
                    }).catch(error => {
                        this.$message.error(error);
                    });
                }).catch(error => {});
            }
        },
        created() {
            this.queryPermission()
            this.getMenu()
        }
    }

</script>
<style>
    .el-button--small {
        width: 65px;
        height: 32px;
        font-size: 14px;
    }
    .el-button--primary:hover {
        background:rgba(120,180,255,1)!important;
        color: #FFFFFF!important;
    }
    .el-button--primary:focus {
        background:rgba(57,129,221,1)!important;
        color: #FFFFFF!important;
    }
</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
</style>